import { createTheme } from '@mui/material/styles';
export const Colors = {
  primary: '#698AFF',
  secondary: '#fff',
  light_gray: '#c2c2c2',
  white: '#fff',
  correctAnswer: '#61cb8e',
  currentQuestionBg: '#698aff14',
  bgColor: '#F4F6FF',
  heading: '#021148',
  blue900: '#2563eb',

  // heading color for this bgColor:'#F4F6FF',
  headingColor: '#021148',
  subHeadingColor: '#35496b',
  paragraphColor: '#5a6783',
  borderColor: '#E1E1E1',

  // popColors
  headingPrimary: '#021148e6',
  subTitleColor: '#787878',

  orgPagesHeader: {
    titleColor: '#000000de',
    descriptionColor: '#808080',
    bg: '#ffffff',
    border: '#E1E1E1',
  },

  // Card Colors
  card: {
    bg: '#ffffff',
    heading: '#021148', // Dark for strong contrast
    cardParagraph: '#3f4859', // Muted for readability
    cardCaption: '#3e434be6', // Subtle, lighter for captions
    cardBorder: '#dce3f2',

    // Course carousel cards
    course: {
      // Modern card styling
      bgColor: 'rgba(255, 255, 255, 0.8)',
      bgColorHover: 'rgba(255, 255, 255, 0.9)',
      backdropFilter: 'blur(10px)',
      borderRadius: '12px',
      border: '1px solid rgba(225, 225, 225, 0.2)',
      borderHover: 'rgba(105, 138, 255, 0.3)',

      // Typography
      heading: '#021148',
      cardParagraph: '#808080',
      cardCaption: '#3e434be6',

      // Shadows and effects
      boxShadow: '0 6px 24px rgba(105, 138, 255, 0.08)',
      boxShadowHover: '0 12px 36px rgba(105, 138, 255, 0.15)',

      // Rating and progress
      ratingColor: '#faaf00',
      progressBar: {
        bg: '#e0e0e0',
        fill: '#698AFF',
        height: '6px',
        borderRadius: '3px',
      },

      // Video/Section count styling
      metaInfo: {
        iconColor: '#698AFF',
        textColor: '#3e434be6',
      },

      // Button styles
      buttons: {
        primary: {
          borderRadius: '8px',
          fontSize: '11px',
          fontWeight: '500',
          bg: '#698AFF',
          bgHover: '#5a7dff',
          color: '#ffffff',
          boxShadowHover: '0 4px 12px rgba(105, 138, 255, 0.3)',
        },
      },
    },

    task: {
      // Modern card styling
      bgColor: 'rgba(255, 255, 255, 0.8)',
      bgColorHover: 'rgba(255, 255, 255, 0.9)',
      backdropFilter: 'blur(10px)',
      borderRadius: '16px',
      border: '1px solid rgba(225, 225, 225, 0.2)',
      borderHover: 'rgba(105, 138, 255, 0.3)',

      // Typography
      heading: '#021148',
      cardParagraph: '#808080',
      cardCaption: '#3e434be6',
      cardBorder: '#dce3f2',

      // Shadows and effects
      boxShadow: '0 8px 32px rgba(105, 138, 255, 0.12)',
      boxShadowHover: '0 16px 48px rgba(105, 138, 255, 0.2)',
      gradientTopBorder: 'linear-gradient(90deg, #698AFF, #9C7BFF)',

      // Interactive elements
      avatarBg: '#698AFF',
      sabTaskIconColor: '#698AFF',
      borderBottom: '#e0e0e0',

      // Priority badge - modern gradient
      priority: {
        bg: 'linear-gradient(135deg, #ff4757, #ff3742)',
        color: '#ffffff',
        boxShadow: '0 2px 8px rgba(255, 71, 87, 0.3)',
      },

      // File required indicator
      isFileRequired: 'red',

      // Modern status labels
      isEndingTodayLabel: {
        bg: 'rgba(239, 68, 68, 0.1)',
        border: '1px solid rgba(239, 68, 68, 0.2)',
        titleColor: '#ef4444',
        boxShadow: '0 4px 12px rgba(239, 68, 68, 0.15)',
        backdropFilter: 'blur(8px)',
        borderRadius: '0px 12px 12px 0px',
      },
      isEndingTomorrowLabel: {
        bg: 'rgba(255, 165, 0, 0.1)',
        border: '1px solid rgba(255, 165, 0, 0.2)',
        titleColor: '#ff8c00',
        boxShadow: '0 4px 12px rgba(255, 165, 0, 0.15)',
        backdropFilter: 'blur(8px)',
        borderRadius: '0px 12px 12px 0px',
      },

      // Button styles
      buttons: {
        edit: {
          borderColor: 'rgba(105, 138, 255, 0.3)',
          color: '#698AFF',
          borderColorHover: '#698AFF',
          bgHover: 'rgba(105, 138, 255, 0.08)',
          boxShadowHover: '0 4px 12px rgba(105, 138, 255, 0.2)',
          borderRadius: '12px',
        },
        delete: {
          borderColor: 'rgba(239, 68, 68, 0.3)',
          color: '#ef4444',
          borderColorHover: '#ef4444',
          bgHover: 'rgba(239, 68, 68, 0.08)',
          boxShadowHover: '0 4px 12px rgba(239, 68, 68, 0.2)',
          borderRadius: '12px',
        },
        success: {
          borderColor: 'rgba(97, 203, 142, 0.3)',
          color: '#61cb8e',
          borderColorHover: '#61cb8e',
          bgHover: 'rgba(97, 203, 142, 0.08)',
          boxShadowHover: '0 4px 12px rgba(97, 203, 142, 0.2)',
          borderRadius: '12px',
        },
      },

      // Footer elements
      footer: {
        deadlineContainer: {
          bg: 'rgba(105, 138, 255, 0.05)',
          border: '1px solid rgba(105, 138, 255, 0.1)',
          borderRadius: '8px',
          iconColor: '#698AFF',
        },
        avatar: {
          border: '2px solid rgba(255, 255, 255, 0.8)',
          boxShadow: '0 2px 8px rgba(105, 138, 255, 0.2)',
        },
      },

      // Divider
      divider: {
        bg: 'linear-gradient(90deg, transparent, rgba(105, 138, 255, 0.3), transparent)',
      },

      contestCode: {
        color: '#4DB6AC',
        borderCOlor: ' #e0f2f1',
      },
    },
  },

  courseVideo: {
    primaryText: '#021148',
    bgColor: '#f5f5f5',
    paragraphColor: '#2B374690',
    bgColorForContainers: '#fff',
    mutedText: '#505050',
    avatarBg: '#354150',
    tabTextColor: '#02114870',
    courseContainerBorder: '#DCE4FF',
    sectionCardBg: '#F7F7F7',
    sectionCardBorder: '#EAEAEA',
    sectionCardIcon: '#787878',
    activeVideoBg: '#F1F3FA',
    mainPrimary: '#698AFF',
    playVideoIconBg: '#F5F7FF',
  },

  hacksthon: {
    bg: '#FFD89B',
    text: '#BA5A00',
  },
  quizContest: {
    bg: '#D6EDFF',
    text: '#35517A',
  },
  draftContest: {
    bg: '#E0E0E0',
    text: '#4F4F4F',
  },

  cardsShadow: 'rgba(105, 138, 255, 0.05)',

  courseCreator: {
    primaryText: '#021148',
    bgColor: '#f5f5f5',
    paragraphColor: '#2B374690',
    bgColorForContainers: '#fff',
    mutedText: '#505050',
    avatarBg: '#354150',
    tabTextColor: '#02114870',
    courseContainerBorder: '#DCE4FF',
    sectionCardBg: '#F7F7F7',
    sectionCardBorder: '#EAEAEA',
    sectionCardIcon: '#787878',
    activeVideoBg: '#F1F3FA',
    mainPrimary: '#698AFF',
    playVideoIconBg: '#F5F7FF',
    border: '#EAEAEA',
  },
};

const theme = createTheme({
  palette: {
    primary: {
      main: Colors.primary,
    },
    secondary: {
      main: Colors.secondary,
    },
    ErrorBtn: {
      main: '#d32f2f',
      contrastText: '#fff',
    },
    ChipColor: {
      main: '#F4F7FF',
      contrastText: '#698AFF',
    },
  },

  breakpoints: {
    values: {
      xs: 0,
      xsSmall: 350,
      xsMedium: 410,
      sm: 600,
      md: 900,
      mdx: 970,
      mds: 1000,
      slg: 1100,
      lg: 1200,
      xlg: 1325,
      xl: 1536,
      uxl: 2000,
    },
  },

  typography: {
    fontFamily: "'Poppins', sans-serif",
  },
});

export default theme;
